import type { QueryPagination } from 'components/Table/Pagination'
import { endpoints } from 'constants/endpoints'
import api from 'services/api'

import { toCustomersRequestDataApi, toCustomersResponseData } from './adapters'
import type { CustomersRequestData, CustomersResponseData, CustomersResponseDataApi } from './types'

export const getCustomers = async (
  body: CustomersRequestData,
  pagination: QueryPagination,
): Promise<CustomersResponseData> => {
  const bodyApi = toCustomersRequestDataApi(body)

  const response = await api.post<CustomersResponseDataApi>(endpoints.customers, bodyApi, {
    params: { ...pagination },
  })

  return toCustomersResponseData(response.data)
}
